import {
  Badge,
  Box,
  Button,
  ButtonSelect,
  Icon,
  Tooltip,
} from "@saviynt/design-system";
import React from "react";
import { useIntl } from "react-intl";
import { useFindingsData } from "../PoliciesFindingsList/context/FindingsDataContext";
import SearchBar from "../PoliciesForm/InventorySidePanel/SummaryTab/components/Ownership/components/SearchBar/SearchBar";

interface FindingsFilterControlsProps {
  isFilterOpen: boolean;
  handleFilterClick: () => void;
  handleExportOnClick: () => void;
  searchValue: string;
  onSearchChange: React.Dispatch<React.SetStateAction<string>>;
  hasSelectedFilters: boolean;
}

export default function FindingsFilterControls({
  isFilterOpen,
  handleFilterClick,
  handleExportOnClick,
  searchValue,
  onSearchChange,
  hasSelectedFilters,
}: FindingsFilterControlsProps) {
  const intl = useIntl();
  const { recordsCount } = useFindingsData();
  const isExportDisabled = recordsCount.loadedRecordsCount === 0;

  const buttonSelectShowBadge =
    !isFilterOpen && hasSelectedFilters ? (
      <Badge kind="dot" color="primary" dataTestId="filter-badge" />
    ) : null;

  return (
    <Box
      className="flex items-center gap-4"
      dataTestId="NHI-Findings-FilterControls"
    >
      <Box className="flex gap-4 items-center w-5/6">
        <SearchBar
          value={searchValue}
          setValue={onSearchChange}
          dataTestId="NHI-Findings-SeachBar"
        />
      </Box>
      <Box className="ISPM-Workforce-Identities-toolbar-filter">
        <ButtonSelect
          label={intl.formatMessage({
            defaultMessage: "Filter",
            id: "vxq3Bj",
            description: "Label for filter button",
          })}
          isOpen={isFilterOpen}
          onClick={handleFilterClick}
          size="medium"
          prefixIcon={
            <Icon kind="Filter" color="--color-foreground-neutral-subtle" />
          }
          dataTestId="NHI-Inventory-Filter"
          BadgeComp={buttonSelectShowBadge}
        />
      </Box>
      <Box className="ml-auto flex items-center">
        <Tooltip
          text={intl.formatMessage({
            defaultMessage: "Export Findings",
            description: "Export Findings Button Tooltip Text",
            id: "LFHW1y",
          })}
          placement="left"
        >
          <Button
            className="ISPM-Identities-toolbar-export"
            aria-label={intl.formatMessage({
              defaultMessage: "Export Findings data",
              description: "Export Findings Button Tooltip Text",
              id: "ciLabv",
            })}
            type="button"
            kind="outlined"
            leftIcon={<Icon kind="Export" />}
            onClick={handleExportOnClick}
            isDisabled={isExportDisabled}
            dataTestId="NHI-Findings-ExportButton"
          />
        </Tooltip>
      </Box>
    </Box>
  );
}
